import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteContact = async (contactId: string): Promise<boolean> =>
  axios.delete(`/management/contact/removecontact?contactId=${contactId}`).then((res) => res?.data?.result)

type Props = {
  contactId: string
}

export const useManagementDeleteContact = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteContact'],
    mutationFn: ({ contactId }: Props) => deleteContact(contactId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted contact.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete contact, please try again.')
      }
    },
    throwOnError: false
  })
